import {FileFormat} from './fileFormat';

export function generateFileName(fileFormat: FileFormat) {
  return `file_${new Date().toISOString()}.${fileFormat}` as const;
}
